'use strict';

angular.module('PageControl', []);
